import React from 'react';
import { format, isValid, parse } from 'date-fns';

export var ClearIndicator = null;

export var defaultTimes = ['09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00'];

export var DropdownIndicator = function DropdownIndicator() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      Icon = _ref.icon;

  return Icon ? React.createElement(
    'span',
    { role: 'img' },
    React.createElement(Icon, null)
  ) : null;
};

export function parseDateIntoStateValues(value, dateValue, timeValue, zoneValue) {
  var parsed = parse(value);
  var valid = isValid(parsed);
  return {
    dateValue: valid ? format(parsed, 'YYYY-MM-DD') : dateValue,
    timeValue: valid ? format(parsed, 'HH:mm') : timeValue,
    zoneValue: valid ? format(parsed, 'ZZ') : zoneValue
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/datetime-picker/dist/esm/internal/index.js
// module id = 122
// module chunks = 0